import React from "react";
import {Row} from "react-bootstrap";
import {Col} from "react-bootstrap";
import useTranslationAdmin from "../useTranslationAdmin.js";
import useShowLoader from "../../common/loading-widgets/useShowLoader.js";
import RefreshButton from "../../common/widgets/RefreshButton.js";
import "./DetailedJobListBlock.scss";
import DetailedJobList from "./DetailedJobList.js";

function DetailedJobListBlock({filter}) {
  const { t, loading: tLoading } = useTranslationAdmin();
  useShowLoader(tLoading, "DetailedJobListBlock");

  return (
    <div className="DetailedJobListBlock">
      <Row>
        <Col>
          <h1>{t("admin:admin_job_list_title")}</h1>
        </Col>
        <Col className={"button-col"}>
          <RefreshButton />
        </Col>
      </Row>
      <Row>
        <Col>
          <DetailedJobList filter={filter}/>
        </Col>
      </Row>
    </div>
  );
}

export default DetailedJobListBlock;
